export const METADATA_FORM = "Metadatos";
export const BOX_METADATA_FORM = "Metadatos de etiqueta";
